export default "__VITE_ASSET__enAw49Mx__"